// extracted by mini-css-extract-plugin
module.exports = {"ruleContainer":"ruleContainer____5zrT","ruleSection":"ruleSection___2MVks","underline":"underline___DZlV0","faq":"faq___3i_BH","red":"red___1m1UD","bold":"bold___3qE3k"};